import React, { useEffect, useState } from "react";
import "./Withdraw.scss";
import { PayemntItem } from "./WithdrawUi/PayemntItem/PayemntItem";

import { userDeposit } from "../../../../../../../common/types/AdminInfo/userDeposit";
import { AdminPanel } from "../../../../../../../services";
import { t } from "i18next";

const Withdraw = () => {
  const [paymentMethods, setPaymentMethods] = useState<userDeposit[] | []>([]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<
    userDeposit | any
  >();
  const [buttonSubmitDisabled, setButtonSubmitDisabled] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [inputFocused, setInputFocused] = useState(false);

  const onChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleFocus = () => {
    setInputFocused(true);
  };

  const handleBlur = () => {
    if (inputValue.length === 0) {
      setInputFocused(false);
    } else {
      setInputFocused(true);
    }
  };

  const handleMoveToPay = () => {
    async function getPaymentUrl() {
      const res = await AdminPanel.userPay({
        data: {
          amount: Number(inputValue) * 100,
          currency: "TRY",
          payment_aggregator_id: selectedPaymentMethod?.payment_aggregator_id,
          service_id: selectedPaymentMethod?.service_id,
        },
        params: "?filter[type]=2",
      });
      window.open(res.data.redirectUrl, "_blank");
    }
    getPaymentUrl();
  };

  useEffect(() => {
    if (Number(inputValue) >= Number(selectedPaymentMethod?.currencies[0].min)) {
      setButtonSubmitDisabled(false);
    } else {
      setButtonSubmitDisabled(true);
    }
    if (Number(inputValue) <= Number(selectedPaymentMethod?.currencies[0].max)) {
      setButtonSubmitDisabled(false);
    } else {
      setButtonSubmitDisabled(true);
    }
  }, [inputValue, selectedPaymentMethod]);

  useEffect(() => {
    async function getPayemntMethods() {
      const res = await AdminPanel.userDeposit("?filter[type]=1");
      setPaymentMethods(res.data);
      setSelectedPaymentMethod(res.data[0]);
    }
    getPayemntMethods();
  }, []);
  return (
    <>
      <div className="overlay-header">{t("admin.Withdraw")}</div>
      <div className="dep-w-info-bc" data-scroll-lock-scrollable="">
        <div className="m-block-nav-items-bc">
          {paymentMethods.map((item) => {
            return (
              <PayemntItem
                key={item.id}
                paymentInfo={item}
                selectedPaymentMethod={selectedPaymentMethod}
                setSelectedPaymentMethod={setSelectedPaymentMethod}
                setButtonSubmitDisabled={setButtonSubmitDisabled}
                setInputValue={setInputValue}
              />
            );
          })}
        </div>
      </div>
      <div className="payment-info-bc" data-scroll-lock-scrollable="">
        <div className="description-c-row-bc deposit">
          <div className="description-c-row-column-bc texts">
            <div className="description-c-row-c-title-bc ">
              <div className="description-c-r-c-t-column-bc">
                <span
                  className="description-title  ellipsis"
                  title="Payment name"
                >
                  {t("admin.Paymentname")}
                </span>
                <span className="description-value">
                  {selectedPaymentMethod?.name}
                </span>
              </div>
              <div className="description-c-r-c-t-column-bc">
                <span className="description-title  ellipsis" title="Fee">
                  {t("admin.Fee")}
                </span>
                <span className="description-value">
                  {/* {mockPaymentData[selectedPaymentMethod]?.Fee} */}
                </span>
              </div>
              <div className="description-c-r-c-t-column-bc">
                <span
                  className="description-title  ellipsis"
                  title="Process Time"
                >
                  {t("admin.ProcessTime")}
                </span>
                <span className="description-value">
                  {/* {mockPaymentData[selectedPaymentMethod]?.ProcessTime} */}
                </span>
              </div>
              <div className="description-c-r-c-t-column-bc">
                <span className="description-title  ellipsis" title="Min">
                  {t("admin.Min")}
                </span>
                <span className="description-value">
                  {selectedPaymentMethod?.currencies[0].min} ₺
                </span>
              </div>
              <div className="description-c-r-c-t-column-bc">
                <span className="description-title  ellipsis" title="Max">
                  {t("admin.Max")}
                </span>
                <span className="description-value">
                  {selectedPaymentMethod?.currencies[0].max} ₺
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="WithdrawAmount-All">
          <ul className="WithdrawAmount-Row">
            <li className="WithdrawAmount-Row-Title">{t("admin.WithdrawableAmount")}</li>
            <li className="WithdrawAmount-Row-Value">0.00 ₺</li>
          </ul>
          <ul className="WithdrawAmount-Row">
            <li className="WithdrawAmount-Row-Title">{t("admin.Balance")}</li>
            <li className="WithdrawAmount-Row-ValueBalance">0.00 ₺</li>
          </ul>
          <ul className="WithdrawAmount-Row">
            <li className="WithdrawAmount-Row-Title">{t("admin.Unplayedamount")}</li>
            <li className="WithdrawAmount-Row-Value">0.00 ₺</li>
          </ul>
        </div>

        <div className="deposit-method-description HedefHavale">
          {selectedPaymentMethod?.description}
        </div>
        <div className="withdraw-form-l-bc">
          <>
            <div className="u-i-p-control-item-holder-bc">
              <div
                className={`form-control-bc default ${
                  inputFocused ? "focused" : ""
                }`}
              >
                <label className="form-control-label-bc inputs">
                  <input
                    type="text"
                    inputMode="decimal"
                    className="form-control-input-bc"
                    name="name"
                    step={0}
                    defaultValue=""
                    value={inputValue}
                    onChange={onChangeInput}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                  />
                  <i className="form-control-input-stroke-bc" />
                  <span className="form-control-title-bc ellipsis">value</span>
                </label>
              </div>
            </div>
            <div className="u-i-p-c-footer-bc">
              <button
                className="btn a-color deposit "
                title="DEPOSIT"
                disabled={buttonSubmitDisabled}
                onClick={handleMoveToPay}
              >
                <span>{t("admin.Deposit")}</span>
              </button>
            </div>
          </>
        </div>
      </div>
    </>
  );
};

export { Withdraw };
